// extracted by mini-css-extract-plugin
module.exports = {"spinCenter":"spinCenter--2Wf60"};